import React, { useState } from "react"
import { Col, Container, Modal, Row } from "react-bootstrap"
import Checkbox from "../../common/checkbox/checkbox.component"
import { defineMessages, FormattedMessage, injectIntl } from "react-intl"
import ActionButton from "../../common/button/actionbutton.component"
import { SIGN_UP_OPTION, START_UP_GUIDE_OPTION } from "../../state/onboarding/DataFlowTypes"
import { Intl } from "../../state/helpers/IntlProps"

type OwnProps = {
    intl: Intl,
    onStepCompletedCallback: (payload) => void,
    title: string
    options: Array<START_UP_GUIDE_OPTION | SIGN_UP_OPTION>
    messages: defineMessages
}

const SurveyComponent = (props: OwnProps) => {
    const [selectedOptions, setSelectedOptions] = useState(new Set<START_UP_GUIDE_OPTION | SIGN_UP_OPTION>())
    const [collapsedView, setCollapsedView] = useState(true)

    const handleChecked = (isChecked: boolean, option: START_UP_GUIDE_OPTION | SIGN_UP_OPTION) => {
        if (isChecked) {
            selectedOptions.add(option)
            setSelectedOptions(new Set(selectedOptions))
        } else {
            selectedOptions.delete(option)
            setSelectedOptions(new Set(selectedOptions))
        }
    }

    const isChecked = (option: START_UP_GUIDE_OPTION | SIGN_UP_OPTION) => {
        return selectedOptions.has(option)
    }

    let options = props.options
    if (collapsedView) {
        options = props.options.slice(0, 5)
    }

    return (
        <Modal.Dialog>
            <Modal.Header>
                <FormattedMessage
                    id="onboarding.survey_component.description"
                    defaultMessage="Help us configure your account"
                />
            </Modal.Header>

            <Modal.Body>
                <Container>
                    <Row className='m-3 mb-5'>
                        <Col>
                            <h1 className="text-center custom-lead text-custom-primary">
                                {props.title}
                            </h1>
                        </Col>
                    </Row>

                    {options && options.map((option, i) => {
                        return (
                            <Row key={i} className='m-3 flex-nowrap'>
                                <Col />

                                <Col sm={"auto"}>
                                    <Checkbox
                                        id={option}
                                        className={"mr-3"}
                                        checked={isChecked(option as START_UP_GUIDE_OPTION)}
                                        onChange={(isChecked) => handleChecked(isChecked, option as START_UP_GUIDE_OPTION)}
                                    />
                                </Col>

                                <Col className={"w-75"} md="auto">
                                    <label htmlFor={option}>{props.intl.formatMessage(props.messages[option])}</label>
                                </Col>
                            </Row>
                        )
                    })}

                    {props.options.length > 5 &&
                        <Row className='m-4'>
                            <Col className={"text-center"}>
                                <a className={""} onClick={() => { setCollapsedView(!collapsedView) }}>
                                    {collapsedView ?
                                        <FormattedMessage
                                            id="onboarding.survey_component.show_more_btn"
                                            defaultMessage="Show more"
                                        /> :
                                        <FormattedMessage
                                            id="onboarding.survey_component.show_less_btn"
                                            defaultMessage="Show less"
                                        />
                                    }
                                </a>
                            </Col>
                        </Row>
                    }

                    <Row className='m-3'>
                        <Col className={"mt-4"}>
                            <ActionButton
                                disabled={selectedOptions.size == 0}
                                className={"btn-block btn btn-primary button"}
                                onClick={() => props.onStepCompletedCallback(selectedOptions)}>
                                <FormattedMessage
                                    id="onboarding.survey_component.submit_btn"
                                    defaultMessage="Submit"
                                />
                            </ActionButton>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
        </Modal.Dialog>
    )
}

export default injectIntl(SurveyComponent)


// WEBPACK FOOTER //
// ./src/onboarding/components/SurveyComponent.tsx